import React from 'react';
import './editaddprojectroles.css';

const EditAddProjectRoles = ({onClose, handleAddRole}) => {

    return (
        <div className="editaddroles-popup-container">
            <div className="editaddroles-popup">
                <button className='editaddroles-closeBtn' onClick={onClose}><i class="fa-solid fa-x" /></button>
                <div className="editaddroles-popupcontent">
                    <h2 style={{ fontWeight: '400' }}>Add Role</h2>
                    <form style={{ marginTop: '1rem' }} onSubmit={handleAddRole}>
                        <input type='text' className='editaddroles-forminput' name='roleName' placeholder='Role Name' required />
                        <textarea className='editaddroles-forminput' style={{ resize: 'vertical', maxHeight: '15rem', minHeight: '8rem' }} name='roleDesc' placeholder='Description' required />
                        <input type='submit' className='editaddroles-forminput' value='Add' style={{ backgroundColor: '#09CE78', color: 'white', paddingTop: '0.6rem', paddingBottom: '0.6rem', marginTop: '1rem' }} />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditAddProjectRoles;